import { createContext } from 'react'

export const HighlightingContext = createContext({
  highlightedElementId: '',
  customElement: null,
  hideChildrenOnMobile: false,
  highlightElement: (elementId, customElement, hideChildrenOnMobile) => {},
  resetHighlighting: () => {},
})
